export const setSessionRedirectionData = (redirectionData) => {
  sessionStorage.setItem("redirectData", JSON.stringify(redirectionData));
};

export const getRedirectionData = () => {
  return JSON.parse(sessionStorage.getItem("redirectData"));
};
